<div class="container overflow-hidden">
    <h1 mat-dialog-title class="title">{{ data.title }}</h1>
    <div mat-dialog-content class="content">
        {{ data.message }}
    </div>
    <div mat-dialog-actions class="actions">
      <button type="button" class="btn btn-success" [mat-dialog-close]="true">{{ 'yes' | translate }}</button>
      <button type="button" class="btn btn-danger" mat-dialog-close cdkFocusInitial>{{ 'cancel' | translate}}</button>
    </div>
</div>